import {
    refreshCartApi,
    updatePackageApi,
    updateSingleProductApi,
    updateCartEmailApi, fetchCartGiftsApi
} from '../api/cartApi';

import {
    UPDATE_PACKAGE,
    UPDATE_SINGLE_PRODUCT,
    REMOVE_PACKAGE_ITEM,
    UPDATE_CART_EMAIL,
    EMPTY_CART,
    REFRESH_CART, FETCH_CART_GIFTS
} from './actionTypes';

export function refreshCart(currency, cartId) {
    const request = refreshCartApi(currency, cartId);
    return {
        type: REFRESH_CART,
        payload: request
    };
}

export function updatePackage(packageId, packageData, currency, cartId) {
    const request = updatePackageApi(packageId, packageData, currency, cartId);
    return {
        type: UPDATE_PACKAGE,
        payload: request
    };
}

export function updateSingleProduct(amount, productId, currency, cartId) {
    const request = updateSingleProductApi(amount, productId, currency, cartId);
    return {
        type: UPDATE_SINGLE_PRODUCT,
        payload: request
    };
}

export function updateCartEmail(email, cartId) {
    const request = updateCartEmailApi(email, cartId);
    return {
        type: UPDATE_CART_EMAIL,
        payload: request
    };
}

export function fetchCartGifts(country) {
    const request = fetchCartGiftsApi(country);
    return {
        type: FETCH_CART_GIFTS,
        payload: request
    };
}

export function removePackageItem(packageIndex, itemIndex) {
    return {
        type: REMOVE_PACKAGE_ITEM,
        payload: { packageIndex: packageIndex, itemIndex: itemIndex }
    };
}

export function emptyCart() {
    return {
        type: EMPTY_CART,
        payload: null
    };
}
